import React from 'react'
import Menu from '../component/Menu';
import HeaderContact from '../component/HeaderContact';
import Body from '../component/Body';


const Contact = () => {
  return (
    <div>
       <Menu />
       <HeaderContact />
       <Body />
    </div>
  )
}

export default Contact
